











import { Component, Vue, Prop } from 'vue-property-decorator';
// eslint-disable-next-line no-unused-vars
import { IAdditionalSigner } from "@/utils/types";
import { RouteName } from '@/router';

@Component({})
export default class AdditionalSignerButton extends Vue {
  @Prop({ default: () => [] }) additionalSigners!: IAdditionalSigner[];
  @Prop() statementId!: string;

  get showButton() {
    const data = this.additionalSigners.filter((item: IAdditionalSigner) => {
      return item.currentUser && !item.signed;
    });
    return data && data.length > 0;
  }

  goSignerPage() {
    this.$router.push({
      name: RouteName.ADDITIONAL_SIGNERS,
      params: { statementId: this.statementId },
    });
  }
}
